import type { ReactNode } from 'react';

type Tone = 'turquoise' | 'brass' | 'red' | 'green' | 'gray';

const tones: Record<Tone, string> = {
  turquoise: 'bg-blue-50 text-blue-800 ring-blue-200',
  brass: 'bg-[#fbf4e2] text-brass-ink ring-[#ecd9a4]',
  red: 'bg-red-50 text-red-800 ring-red-200',
  green: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  gray: 'bg-gray-50 text-gray-700 ring-gray-200',
};

/** Small status label used for transaction and invoice states */
export default function StatusBadge({ tone, children }: { tone: Tone; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${tones[tone]}`}>
      <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {children}
    </span>
  );
}
